import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormGroup, FormText, Input, Label } from "reactstrap";
import { useStepperContext } from "app/contexts/stepper";
import { toast } from "react-hot-toast";
import { useInscripcionContext } from "../../inscripcion-context";
import { LoadingButton } from "@mui/lab";

export function ArchivosForm() {
  const stepper = useStepperContext();
  const { inscribir, isSending } = useInscripcionContext();

  const [archivos, setArchivos] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      return await inscribir({ archivos });
    } catch (error) {
      console.log(error.message);

      return toast.error(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline">
              <strong>Archivos adjuntos</strong>
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <Label for="files">Archivos</Label>

              <Input
                id="files"
                type="file"
                multiple
                onChange={(e) => setArchivos(e.target.files)}
                required
              />

              <FormText>
                Por favor, seleccione uno o más archivos para subir
              </FormText>
            </FormGroup>
          </Grid>

          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="end"
              spacing={1}
              alignItems="center"
            >
              {!stepper.isFirstStep && (
                <Button variant="outlined" size="small" onClick={stepper.back}>
                  Atrás
                </Button>
              )}

              <LoadingButton
                type="submit"
                variant="contained"
                size="small"
                loading={isSending}
              >
                Inscribir
              </LoadingButton>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
